(() => {
  'use strict';

  // The language and currency switchers are plain <details> elements: no JavaScript is
  // needed to open them, submit them or reach them from the keyboard, and that is on
  // purpose — the shop must stay usable with scripts blocked. What a bare <details> does
  // not do is close when you look away from it, so a panel opened by accident follows you
  // down the page until you find the trigger again. That, and only that, is what this adds.
  const SEL = '[data-lang-switch], [data-currency-switch]';
  // Written out rather than composed from SEL: a selector list is comma-separated, so
  // appending "[open]" to it would only ever qualify the last item of the list.
  const SEL_OPEN = '[data-lang-switch][open], [data-currency-switch][open]';

  const closeOthers = (keep) => {
    document.querySelectorAll(SEL).forEach((d) => {
      if (d !== keep && d.open) d.open = false;
    });
  };

  document.addEventListener('click', (e) => {
    closeOthers(e.target instanceof Element ? e.target.closest(SEL) : null);
  });

  // Focus can leave by keyboard without a click ever happening.
  document.addEventListener('focusin', (e) => {
    closeOthers(e.target instanceof Element ? e.target.closest(SEL) : null);
  });


  // The localization forms carry `return_to` so the POST lands the visitor back on the page
  // they were reading rather than on the homepage. Liquid fills it with `request.path`,
  // which is correct for a normally rendered page — but the cart drawer is re-rendered
  // through the Section Rendering API after every add-to-cart, and there `request.path` is
  // the render request's path, not the shopper's. Switching currency from the drawer then
  // dropped them on the homepage. Rewritten here at submit time, where the real location is
  // known; the Liquid value stays as the no-JavaScript fallback.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest(SEL) && !form.classList.contains('meningea-curline')) return;
    const field = form.querySelector('input[name="return_to"]');
    if (field) field.value = location.pathname + location.search;
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelector(SEL_OPEN);
    if (!open) return;
    open.open = false;
    // Returning focus to the trigger, rather than leaving it on a button that has just
    // been hidden, is what keeps tab order from jumping back to the top of the page.
    open.querySelector('summary')?.focus();
  });
})();
